import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

export const PrivacyPolicyContainer = styled.div`
  text-align: left;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  &.mobile-privacy-policy {
    padding: 0 15px;

    @media (min-width: 480px) {
      padding: 0 20px;
    }

    @media (min-width: 768px) {
      padding: 0 30px;
    }

    @media (min-width: 1024px) {
      padding: 0 40px;
    }
  }

  label {
    font-size: 14px;
    line-height: 1.5;

    @media (min-width: 768px) {
      font-size: 15px;
    }

    @media (min-width: 1024px) {
      font-size: 16px;
    }
  }
`;

export const PrivacyPolicyLink = styled.a`
  color: ${colors.text.link};
  text-decoration: none;
  word-wrap: break-word;
  word-break: break-word;
  display: inline;
  min-height: 44px;
  line-height: 1.5;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      text-decoration: underline;
    }
  }

  &:active {
    opacity: 0.7;
  }

  @media (max-width: 479px) {
    font-size: 14px;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;
